<template>
  <v-card class="px-3 half-radius" flat>
    <v-card-title class="custom-text py-1">
      <v-btn v-if="closable" icon @click="$emit('input', false)">
        <v-icon color="#29284c">mdi-arrow-left</v-icon>
      </v-btn>
      <v-spacer />
      <slot name="title"> </slot>
    </v-card-title>
    <slot name="title-text" />
    <div class="px-3 d-flex" style="gap: 10px">
      <div class="text-center flex-grow-1 input-section">
        <div class="text-center pb-4 font-weight-medium" style="font-size: 24px; color: #29284c">
          Voice
        </div>
        <app-microphone :recording="recording" @click="onRecord" size="100" />
        <v-fade-transition>
          <app-time-stamp
            v-if="!$vuetify.breakpoint.xs"
            :time="timeStamp"
            :recording="recording"
            class="mt-2 mb-2 ml-auto mr-auto"
            style="width: 100px"
            >{{ formatTime(timeStamp) }}</app-time-stamp
          >
        </v-fade-transition>
        <v-btn class="text-capitalize" color="#29284c" text @click="uploadAudioFile">
          Upload Audio
          <v-icon right color="#29284c" style="transform: rotateX(180deg)">
            $vuetify.icons.appDownload
          </v-icon>
        </v-btn>
      </div>
      <div
        @click="onFocus"
        class="input-section editor-section flex-grow-1"
        :class="{
          'placeholder-icon':
            showPlaceholderIcon &&
            comment.text &&
            comment.text.content[0].text === defaultPlaceholderText,
        }"
      >
        <div class="text-center pb-4 font-weight-medium" style="font-size: 24px; color: #29284c">
          Writing
        </div>
        <div :style="noIncrease ? '' : 'min-height: 200px'">
          <app-editor
            v-model="comment.text"
            ref="editor"
            :editable="!content"
            @click.native.stop="showPlaceholderIcon = false"
          />
        </div>
      </div>
    </div>
    <v-card-actions class="pt-7 pb-3">
      <v-fade-transition>
        <app-remove-button v-if="!recording && audioUrl" @click="removeAudio" />
      </v-fade-transition>
      <div class="pb-9">
        <div class="absolute">
          <app-button-player
            class="ml-4"
            v-if="computedSrc"
            :src="computedSrc"
            :class="{ commenting: commentDialog, fade: !commentDialog }"
          />
        </div>
      </div>
      <v-spacer />
      <app-create-button
        v-model="snackbar"
        :disabled="recording || !!disabled"
        @click="create"
        confirmText="You won't be able to modify your recording and/or writing when you save. Are you sure you want to save your current job?"
        :snackbarText="snackbarText"
      />
    </v-card-actions>
  </v-card>
</template>
<script>
import Editor from "@/components/Utils/Editor.vue";
import RemoveButton from "@/components/Lessons/Lesson/components/RemoveButton.vue";
import CreateButton from "@/components/Lessons/Lesson/components/CreateButton.vue";
import audioMixin from "@/mixins/audioMixin";
import ButtonPlayer from "./ButtonPlayer.vue";
import Microphone from "./Microphone.vue";
import TimeStamp from "./TimeStamp.vue";

const defaultPlaceholderText = "Type your answer here (if applicable)...";

export default {
  components: {
    appEditor: Editor,
    appMicrophone: Microphone,
    appRemoveButton: RemoveButton,
    appCreateButton: CreateButton,
    appButtonPlayer: ButtonPlayer,
    appTimeStamp: TimeStamp,
  },
  props: {
    closable: {
      required: false,
      default: true,
      type: Boolean,
    },
    content: String,
    src: String,
    disabled: Boolean,
    commentDialog: Boolean,
    noIncrease: Boolean,
    showPlaceholder: Boolean,
  },
  mixins: [audioMixin],
  data() {
    return {
      snackbar: false,
      snackbarText: "",
      comment: {
        text: null,
      },
      showPlaceholderIcon: true,
      defaultContent: () => ({
        type: "doc",
        content: [
          {
            type: "paragraph",
            content: [
              {
                type: "text",
                text: this.showPlaceholder ? defaultPlaceholderText : "",
              },
            ],
          },
        ],
      }),
    };
  },
  computed: {
    computedSrc() {
      if (this.src) {
        return this.src;
      } else if (this.audioUrl) {
        return this.audioUrl;
      } else if (this.audioBlob) {
        return this.audioBlob;
      } else return "";
    },
  },
  methods: {
    async create() {
      this.comment.audio = this.audioUrl;
      this.comment.audioBlob = this.audioBlob;
      const profile = this.$store.getters.profile;
      this.comment.teacher_name = `${profile.first_name} ${profile.last_name}`;
      this.$emit("new-comment", this.comment);
    },
    reset() {
      if (this.recording) {
        this.onRecord();
      }
      setTimeout(() => {
        this.comment = {};
        this.comment.text = this.defaultContent();
        this.$refs.editor.editor.setContent(this.comment.text);
        this.removeAudio();
      }, 300);
    },
    onFocus() {
      this.showPlaceholderIcon = false;
      this.$refs.editor.editor.focus("end");
    },
  },
  watch: {
    content(value) {
      if (value) {
        this.comment.text = JSON.parse(value);
      }
    },
  },
  created() {
    if (this.content) {
      this.comment.text = JSON.parse(this.content);
    } else {
      this.comment.text = this.defaultContent();
    }
  },
};
</script>
<style scoped lang="scss">
.input-section {
  border: 1px #29284c solid;
  border-radius: 4px;
  padding: 10px 4px;
}

.editor-section {
  max-width: calc(50% - 10px);
}

.placeholder-icon {
  background-image: url("../../../../assets/keyboard.svg");
  background-size: 100px;
  background-position: center 100px;
  background-repeat: no-repeat;
}
</style>
